// Global imports
import { useEffect } from 'react';
// Module imports
import { DataLayerObject } from './_data-layer-types';
import { gtmDatalayerPush } from './_helpers';

/**
 * Mounts GTM event properties onto the push function
 */
export const useGtmDatalayerLoadPush = (i: DataLayerObject) => {
  const jsonDlo = JSON.stringify(i);
  useEffect(() => {
    const dataLayer = JSON.parse(jsonDlo);
    gtmDatalayerPush(dataLayer);
  }, [jsonDlo]);
};
